export const AUTH_CONFIG = {
  domain: 'findmakeupartist.eu.auth0.com',
  clientId: 'MwIqCMFuLIMxsjblEPZiC7FyWXHnxB46',
  callbackUrl: 'http://localhost:3000/callback'
};
